import { deleteSecureInformationRequest } from '@commenda/api';
import { KeyedMutator } from 'swr';
import { useNotification } from '../../hooks/useNotification';
import { DeleteConfirmationModal } from '../../molecules';

const DeleteSecureInformationRequestModal = ({
  isShown,
  toggle,
  id,
  token,
  mutate,
}: {
  isShown: boolean;
  toggle: () => void;
  id: string;
  token?: string;
  mutate: KeyedMutator<unknown>;
}) => {
  const { setNotification } = useNotification();

  const onDelete = async () => {
    try {
      const res = await deleteSecureInformationRequest(id, token);
      if (!res.ok) throw new Error('delete failed');
      setNotification({
        show: true,
        valid: true,
        title: 'Success',
        message: 'Request deleted successfully.',
      });
      await mutate();
    } catch {
      setNotification({
        show: true,
        valid: false,
        title: 'Error',
        message:
          'Something went wrong, please try again or contact Team commenda if you need help.',
      });
      throw new Error('delete failed');
    }
  };

  return (
    <DeleteConfirmationModal
      isOpen={isShown}
      onClose={toggle}
      onConfirm={onDelete}
      title="Delete Request"
      message="Are you sure you want to delete this request?"
    />
  );
};

export { DeleteSecureInformationRequestModal };
